<template>
  <nav class="stepnav" :class="{'stepnav__information':checkoutStep=='contact_information'}">
    <a class="checkout_accent_color" :aab="checkoutStep" href="/cart" v-if="utm_medium != 'email'">
      {{ $t('shopping.cart') }}
    </a>
    <a
      v-for="item in nav"
      :key="item.step"
      :class="[
        stepPath[item.step] == 'javascript:;' ? 'test' : 'checkout_accent_color',
        {
          step: checkoutStep == item.step,
        },
      ]"
      :href="stepPath[item.step]"
      @click="checkoutArrive($event,item.step)"
    >
      {{ $t(item.translate) }}
    </a>
  </nav>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: ['cart'],
  data() {
    return {
      cart_hash: null,
      utm_medium: null,
      nav: [
        { step: 'contact_information', translate: 'shopping.information' },
        { step: 'shipping_method', translate: 'shopping.shipping' },
        { step: 'payment_method', translate: 'shopping.payment' },
      ],
    }
  },
  beforeMount() {
    this.cart_hash = this.getCookie('cart_hash')
    this.utm_medium = this.getSearch('utm_medium')
  },
  methods: {
    checkoutArrive(event,step) {
      //处于payment_method页面 点击任意按钮都直接跳回 不需要发请求
      // if(step==='contact_information') return;
      //其余都阻止默认行为
      event.preventDefault();
      //如果等于javascript:; 禁止发请求;
      if(this.stepPath[step] === 'javascript:;') return;
      if (this.checkoutStep === 'payment_method') {
        this.$store.commit('saveBaseState', { checkoutStep: step })
        window.history.replaceState({}, '', this.replaceSearch('step', step, true))
      } else {
        this.$store.dispatch('change_checkout_arrive', step)
      }
    },
  },
  computed: {
    ...mapState({
      news_cart ({news_cart}) {
        return Object.values(news_cart).length ? news_cart : this?.cart || {}
      },
      checkoutStep: ({ checkoutStep }) => checkoutStep,
      checkout_address_2_config: ({ options }) => options?.base?.checkout_address_2_config,
      checkout_phone_config: ({ options }) => options?.base?.checkout_phone_config,
    }),
    shippingVerify() {
      let { address } = this.news_cart
      return (
        address?.last_saved_address ||
        !address?.first_name ||
        (this.checkout_address_2_config == 'required' && !address?.address_2) ||
        (this.checkout_phone_config == 'required' && !address.phone)
      )
    },
    stepPath() {
      return {
        contact_information:
          this.shippingVerify || this.checkoutStep == 'contact_information'
            ? 'javascript:;'
            : this.replaceSearch('step', 'contact_information'),
        shipping_method:
          this.shippingVerify || this.checkoutStep == 'shipping_method'
            ? 'javascript:;'
            : this.replaceSearch('step', 'shipping_method'),
        payment_method:
          !this.news_cart.shipping.chosen_method || this.checkoutStep == 'payment_method' || this.checkoutStep == 'contact_information'
            ? 'javascript:;'
            : this.replaceSearch('step', 'payment_method'),
      }
    },
  },
}
</script>
<style scoped lang='scss'>
.stepnav {
  margin-bottom: 12px;
  text-align: center;
  a {
    color: #128fae;
    font-size: 12px;
    text-decoration: none;
  }

  & > a:not(:last-child)::after {
    content: '\e646';
    font-family: 'iconfont';
    font-weight: 600;
    margin: 0 5px;
  }
  //处在当前页
  .step {
    font-weight: bold;
    color: #333333 !important;
    cursor: text;
  }
  //处在不可点击页
  .test {
    color: #737373;
    cursor: text;
  }
}
</style>
